<template>
  <div class="custom-drawer">
    <div class="drawer-button" @click="openDrawer">
      <slot name="button" />
    </div>

    <div
      class="drawer-overlay"
      v-if="isDrawerOpen"
      @click="closeDrawer"
    ></div>

    <div class="drawer" :class="{ open: isDrawerOpen }">
      <button class="close-button" @click="closeDrawer">
        <custom-icon icon="xmark-icon" color="danger" />
      </button>
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import CustomIcon from '@/components/icon/customIcon.vue'

export default {
  name: 'customDrawer',
  components: {CustomIcon},
  data () {
    return {
      isDrawerOpen: false
    }
  },
  mounted () {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount () {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    openDrawer () {
      this.isDrawerOpen = true
    },
    closeDrawer () {
      this.isDrawerOpen = false
    },
    handleKeydown (event) {
      if (event.key === 'Escape' && this.isDrawerOpen) {
        this.closeDrawer()
      }
    }
  },
  watch: {
    '$route.name': {
      handler () {
        this.closeDrawer()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-drawer {
  .drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(1px);
    z-index: 999;
  }

  .drawer-button {
    cursor: pointer;
  }

  .drawer {
    position: fixed;
    top: 0;
    right: -300px;
    width: 300px;
    max-width: 100%;
    height: 100%;
    background: #fff;
    z-index: 1000;
    transition: all 0.4s ease-out;

    &.open {
      box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
      right: 0;
    }

    .close-button {
      position: absolute;
      top: 12px;
      left: 10px;
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }

    &.left {
      left: -300px;
      right: auto;

      &.open {
        left: 0;
      }
    }

    &.top {
      top: -100%;
      right: 0;
      height: 300px;
      width: 100%;

      &.open {
        top: 0;
      }
    }

    &.bottom {
      bottom: -100%;
      top: auto;
      height: 300px;
      width: 100%;

      &.open {
        bottom: 0;
      }
    }
  }
}
</style>
